export default {
  "1.0.0": "1.5.1",
  "1.1.0": "1.6.1",
  "1.1.1": "1.7.0",
  "1.1.2": "1.7.2",
  "1.1.3": "1.9.0",
} as Record<string, string>;
